import { render, staticRenderFns } from "./BaseMenuItem.vue?vue&type=template&id=00f48ca8&"
import script from "./BaseMenuItem.vue?vue&type=script&lang=ts&"
export * from "./BaseMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./BaseMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports